import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { rolePaths } from "api/apiPaths";
import client from "api/client";
import { RolesRequestModel } from "./model/RolesRequestModel";
import { RolesResponseModel } from "./model/RolesResponseModel";
import { RoleActionsRequestModel } from "./model/actions/RoleActionsRequestModel";
import { RoleDetailResponseModel } from "./model/detail/RoleDetailResponseModel";

export interface IRolesRepository {
  getList(
    params: RolesRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<RoleDetailResponseModel>>;
  createRole(
    body: RoleActionsRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel>>;
  updateRole(
    body: RoleActionsRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel>>;
  deleteRole(params: {
    code: string;
  }): Promise<BaseApiResponseModel<RolesResponseModel>>;
}

class RolesImpl implements IRolesRepository {
  async getList(
    params: RolesRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel[]>> {
    return await client?.get(rolePaths?.LIST, params);
  }
  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<RoleDetailResponseModel>> {
    return await client?.get(rolePaths?.DETAIL, params);
  }
  async updateRole(
    body: RoleActionsRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel>> {
    return await client?.put(rolePaths?.UPDATE, body);
  }
  async createRole(
    body: RoleActionsRequestModel
  ): Promise<BaseApiResponseModel<RolesResponseModel>> {
    return await client?.post(rolePaths?.CREATE, body);
  }
  async deleteRole(params: {
    code: string;
  }): Promise<BaseApiResponseModel<RolesResponseModel>> {
    return await client?.delete(rolePaths?.DELETE, params);
  }
}

export const defaultRoleRepository = new RolesImpl();
